import { loadStripe, Stripe } from '@stripe/stripe-js'

/**
 * Shared Stripe.js promise. Load once per page load per Stripe's guidance.
 * Lazy-initialized so we don't hit Stripe API on module import.
 */
let _stripePromise: Promise<Stripe | null> | null = null

export function getStripePromise(): Promise<Stripe | null> {
  if (_stripePromise) return _stripePromise

  const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
  if (!publishableKey) {
    console.error('VITE_STRIPE_PUBLISHABLE_KEY not configured')
    _stripePromise = Promise.resolve(null)
    return _stripePromise
  }

  _stripePromise = loadStripe(publishableKey)
  return _stripePromise
}
